import React from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import HeaderSelectComponent from "./HeaderComponents/HeaderSelectComponentFeild";
import MenuItem from "@mui/material/MenuItem";
import Button from "@mui/material/Button";
import {Divider, Popover} from "@mui/material";
import TrainingDialog from "components/Dialogs/TrainingDialog/TrainingDialog";
import {useAppSelector, useAppDispatch, store} from "../../redux/store";
import {Loader} from "components/FormComponents/Loader/Loader";
import {useNavigate} from "react-router-dom";
import {setHeader, postRequest, getRequest} from "repository/genericRepository";
import {
  clearAuthState,
  updateSwitchedUserDetails,
  updateHeaderDetails,
  updateUserPreferences,
  updateUserDetail,
} from "../../redux/reducers/authSlice";
import login from "../../assets/login_icon.png";
import profileIcon from "../../assets/profile_icon.png";
import dropdownIcon from "../../assets/dropdown_header_icon.png";
import trainingIcon from "../../assets/training_icon.png";
import contactUs from "../../assets/contact_us_icon.png";
import {headerStyle} from "./headerStyle";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import {
  HEADER_INFORMATION_ENDPOINT,
  LOGIN_CONTENT_ENDPOINT,
  LOGOUT_USER_ENDPOINT,
  OLD_CPS_URL,
  USERPROFILE_ENDPOINT,
} from "commonUtils/globalAPISettings";
import {clearlogs, postLogsToAPI} from "../../redux/reducers/loggerSlice";
import ContactUsDialog from "components/Dialogs/ContactUsDialog/ContactUsDialog";
import {isValidObject, loggedMessage} from "commonUtils/utils";
import {encrypt} from "commonUtils/crypto";
import {
  AxiosErrorCode,
  CPSConstants,
  CPSMessages,
  HttpStatusCode,
  PageNames,
} from "commonUtils/enumerations";
import {
  HttpException,
  ServiceAuthenticationException,
} from "services/exceptionHandlerService";
import {logMessage} from "services/loggerService";
import type {menu} from "../../redux/reducers/authSlice";
import Marquee from "components/Marquee/Marquee";
import Link from "@mui/material/Link";
import MFAPreferedDialog from "components/Dialogs/MFAPreferedDialog/MFAPreferedDialog";

interface LoginContentProps {
  privacy: string;
  termsOfUse: string;
  lillyLogin: string;
  demoSite: string;
  demoStripMessage: string;
  isDeploymentModeOn: boolean;
  cpsLoginMessage: string;
  deploymentMessage: string;
}

export const Header: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [loader, setLoader] = React.useState<boolean>(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [anchorEl2, setAnchorEl2] = React.useState(null);
  const [contactView, setContactView] = React.useState<boolean>(false);
  const [openDialog, setOpenDialog] = React.useState<boolean>(false);
  const [openMFADialog, setOpenMFADialog] = React.useState<boolean>(false);
  const [openLoginAsPopover, setOpenLoginAsPopover] =
    React.useState<boolean>(true);
  const [openProfilePopover, setOpenProfilePopover] =
    React.useState<boolean>(true);
  const [isbannertext, setIsBannerText] = React.useState<boolean>(false);
  const [bannertext, setBannerText] = React.useState<LoginContentProps>();

  const handleClick2 = (event: any) => {
    try {
      logMessage(
        "INFO",
        `User ${userDetails?.userName} has clicked and opened the profile menu popup`,
        PageNames.LOGIN,
      );
      setAnchorEl2(event.currentTarget);
      setOpenProfilePopover(true);
    } catch (error: any) {
      setLoader(false);
      handleAxiosErrors(error);
    }
  };
  const handleClose2 = () => {
    try {
      logMessage(
        "INFO",
        `User ${userDetails?.userName} has closed the profile menu popup`,
        PageNames.DASHBOARD,
      );
      setAnchorEl2(null);
    } catch (error: any) {
      setLoader(false);
      handleAxiosErrors(error);
    }
  };

  const opener2 = Boolean(anchorEl2);
  const id2 = opener2 ? "simple-popover" : undefined;
  const opener = Boolean(anchorEl);
  const id = opener ? "simple-popover" : undefined;

  const handleClick = (event: any) => {
    try {
      logMessage(
        "INFO",
        `User ${userDetails?.userName} has opened the Login as popup`,
        PageNames.DASHBOARD,
      );
      setAnchorEl(event.currentTarget);
      setOpenLoginAsPopover(true);
    } catch (error: any) {
      setLoader(false);
      handleAxiosErrors(error);
    }
  };

  const handleClose = () => {
    try {
      logMessage(
        "INFO",
        `User ${userDetails?.userName} has closed the Login as popup`,
        PageNames.DASHBOARD,
      );
      setAnchorEl(null);
    } catch (error: any) {
      setLoader(false);
      handleAxiosErrors(error);
    }
  };

  const {userDetails, headerDetails} = useAppSelector(state => {
    return state.auth;
  });

  const logs = useAppSelector(state => {
    return state.logs;
  });

  React.useEffect(() => {
    try {
      logMessage(
        "INFO",
        "User has loaded the Dashboard page.",
        PageNames.DASHBOARD,
      );

      const beforeUnloadHandler = () => {
        const authState = store.getState();
        dispatch(
          postLogsToAPI({
            event: logs,
            token: authState?.auth?.authDetails?.token,
          }),
        );
        dispatch(clearlogs());
      };

      window.addEventListener("beforeunload", beforeUnloadHandler);
      window.removeEventListener("beforeunload", beforeUnloadHandler);

      const broadcast = new BroadcastChannel("duplicatetab");
      broadcast.postMessage("FirstTab");
      broadcast.onmessage = event => {
        if (event.data === "FirstTab") {
          broadcast.postMessage(`Sorry! Already open`);
        }
        if (event.data === `Sorry! Already open`) {
          alert(CPSMessages.DUPLICATE_TAB_ALERT);
          window.location.href = CPSConstants.UNAUTH_QUERY_STRING;
        }
      };
      loadHeaderDetails(false, true);
      getBannerContent();
      return () => {
        broadcast.close();
      };
    } catch (error: any) {
      setLoader(false);
      handleAxiosErrors(error);
    }
  }, []);

  const getBannerContent = async () => {
    try {
      setLoader(true);
      const APIHeaders = {
        Authorization: `Bearer ${process.env.REACT_APP_API_AUTH_TOKEN}`,
      };
      const responseData = await getRequest({
        url: LOGIN_CONTENT_ENDPOINT,
        headers: setHeader(APIHeaders),
        timeout: 60000,
        params: {},
      });
      if (
        isValidObject(responseData) &&
        responseData?.demoStripMessage !== ""
      ) {
        setBannerText(responseData);
        setIsBannerText(true);
      } else {
        setIsBannerText(false);
      }
      setLoader(false);
    } catch (error: any) {
      loggedMessage(error, "", PageNames.DASHBOARD);
      setLoader(false);
      handleAxiosErrors(error);
    }
  };

  const loadHeaderDetails = async (isChange: boolean, isLoad: boolean) => {
    try {
      const authState = store.getState();
      const APIHeaders = {
        Authorization: `Bearer ${authState?.auth?.authDetails?.token}`,
      };
      setLoader(true);
      let switchedProfileId = authState?.auth?.userDetails?.switchedProfileId;
      let userId = authState?.auth?.userDetails?.userId;
      let profileId = authState?.auth?.userDetails?.profileId;
      let userName = authState?.auth?.userDetails?.userName;
      if (switchedProfileId <= 0) {
        switchedProfileId = profileId;
        profileId = userId = 0;
        userName = "";
      }
      const responseData = await postRequest({
        url: HEADER_INFORMATION_ENDPOINT,
        headers: setHeader(APIHeaders),
        params: {switchedProfileId, userId, profileId, userName},
        data: {},
      });

      if (isValidObject(responseData)) {
        const payLoad = {
          isJumpToVisible: responseData.isJumpToVisible,
          frJumpTo: responseData.frJumpTo,
          cppJumpTo: responseData.cppJumpTo,
          userList: responseData.userList,
          cpsUserProfiles: responseData.cpsUserProfiles,
          showTrainingPopUp: responseData.showTrainingPopUp,
        };
        setOpenDialog(responseData.showTrainingPopUp);
        dispatch(updateHeaderDetails(payLoad));
        if (
          isChange &&
          Object.keys(responseData?.cpsUserProfiles || {}).length > 1
        ) {
          navigate("/userprofile");
        } else if (
          Object.keys(responseData?.cpsUserProfiles || {}).length === 1
        ) {
          getMenus(responseData?.cpsUserProfiles[0].id, isLoad);
        } else {
          getMenus(
            authState?.auth?.userDetails?.profileId > 0
              ? authState?.auth?.userDetails?.profileId
              : switchedProfileId,
            isLoad,
          );
        }
      }
      setLoader(false);
    } catch (error: any) {
      loggedMessage(error, "", PageNames.DASHBOARD);
      setLoader(false);
      handleAxiosErrors(error);
    }
  };

  const getMenus = async (singleProfileId: number, isLoad: boolean) => {
    try {
      setLoader(true);
      const authState = store.getState();
      const APIHeaders = {
        Authorization: `Bearer ${authState.auth?.authDetails?.token}`,
      };
      const responseData = await postRequest({
        url: USERPROFILE_ENDPOINT + "?profileId=" + singleProfileId,
        headers: setHeader(APIHeaders),
        data: {},
      });
      if (isValidObject(responseData)) {
        let isNew = true;
        const menus: menu[] = responseData?.userPreferences?.menus?.filter(
          function (id: menu) {
            return id.pageToLoad === responseData?.pageToLoad;
          },
        );
        if (isValidObject(menus) && menus.length > 0) {
          isNew = menus[0].isNew;
        }
        if (isNew) {
          // TODO: Code to be removed once CPS migration is Completed.
          const payLoad = {
            userIdentity: authState?.auth?.userDetails?.userIdentity,
            userId: authState?.auth?.userDetails?.userId,
            profileId: singleProfileId,
            userName: authState?.auth?.userDetails?.userName,
            switchedUserId: authState?.auth?.userDetails?.switchedUserId,
            switchedProfileId: authState?.auth?.userDetails?.switchedProfileId,
            switchedUserName: authState?.auth?.userDetails?.switchedUserName,
          };
          dispatch(updateSwitchedUserDetails(payLoad));
          dispatch(updateUserPreferences(responseData?.userPreferences));
          dispatch(updateUserDetail(responseData?.userDetails));
          setLoader(false);
          if (
            !isLoad &&
            window.location.pathname !== "/" + responseData?.pageToLoad
          ) {
            if (
              authState.auth.facultyDetails.facultyId > 0 &&
              responseData?.pageToLoad === "faculty"
            ) {
              navigate("/faculty/facultydetails", {
                state: {
                  params: `facultyId=${authState.auth.facultyDetails.facultyId}&mainPage=0`,
                },
              });
            } else {
              navigate("/" + responseData?.pageToLoad);
            }
          }
        } else if (!isLoad) {
          const userIdentity = encrypt(
            authState.auth?.userDetails?.userIdentity,
          );
          const userId = encrypt(
            authState.auth?.userDetails?.userId?.toString(),
          );
          const profileId = encrypt(singleProfileId);
          const switchedUserId = encrypt(
            authState.auth?.userDetails?.switchedUserId?.toString(),
          );
          const switchedProfileId = encrypt(
            authState.auth?.userDetails?.switchedProfileId?.toString(),
          );
          const switchedUserName = encrypt(
            authState.auth?.userDetails?.switchedUserName?.toString(),
          );
          const token = authState.auth?.authDetails?.token;
          const oldLink = `${OLD_CPS_URL}${responseData?.pageToLoad}?userIdentity=${userIdentity}&userId=${userId}&profileId=${profileId}&switchedUserId=${switchedUserId}&switchedProfileId=${switchedProfileId}&switchedUserName=${switchedUserName}&token=${token}`;
          window.location.href = oldLink;
        } else {
          const payLoad = {
            userIdentity: authState?.auth?.userDetails?.userIdentity,
            userId: authState?.auth?.userDetails?.userId,
            profileId: singleProfileId,
            userName: authState?.auth?.userDetails?.userName,
            switchedUserId: authState?.auth?.userDetails?.switchedUserId,
            switchedProfileId: authState?.auth?.userDetails?.switchedProfileId,
            switchedUserName: authState?.auth?.userDetails?.switchedUserName,
          };
          dispatch(updateSwitchedUserDetails(payLoad));
          dispatch(updateUserPreferences(responseData?.userPreferences));
          dispatch(updateUserDetail(responseData?.userDetails));
          setLoader(false);
        }
      }
    } catch (error: any) {
      loggedMessage(error, "", PageNames.DASHBOARD);
      setLoader(false);
      handleAxiosErrors(error);
    }
  };

  const userChange = (event: any) => {
    try {
      logMessage(
        "INFO",
        `Login as change switch to ${event.target.value}.`,
        PageNames.DASHBOARD,
      );
      setLoader(true);
      const uid = event.target.value as number;
      if (uid === userDetails?.switchedUserId) {
        const payLoad = {
          userIdentity: userDetails?.userIdentity,
          userId: userDetails?.switchedUserId,
          profileId: userDetails?.switchedProfileId,
          userName: userDetails?.switchedUserName,
          switchedUserId: 0,
          switchedProfileId: 0,
          switchedUserName: "",
        };
        dispatch(updateSwitchedUserDetails(payLoad));
        loadHeaderDetails(false, false);
      } else {
        const selectedUser = headerDetails?.userList?.filter(
          ({userId}: {userId: number}) => userId === uid,
        );
        const userName = selectedUser[0].userName;
        const payLoad = {
          userIdentity: userDetails?.userIdentity,
          userId: uid,
          profileId: 0,
          userName,
          switchedUserId: userDetails?.userId,
          switchedProfileId: userDetails?.profileId,
          switchedUserName: userDetails?.userName,
        };
        dispatch(updateSwitchedUserDetails(payLoad));
        loadHeaderDetails(true, false);
      }
      setOpenLoginAsPopover(false);
    } catch (error: any) {
      setLoader(false);
      handleAxiosErrors(error);
    }
  };

  const userProfileChange = (event: any) => {
    try {
      logMessage(
        "INFO",
        `User Profile Change to ${event.target.value}.`,
        PageNames.DASHBOARD,
      );
      const profileId = event.target.value as number;
      const payLoad = {
        userIdentity: userDetails?.userIdentity,
        userId: userDetails?.userId,
        profileId,
        userName: userDetails?.userName,
        switchedUserId: userDetails?.switchedUserId,
        switchedProfileId: userDetails?.switchedProfileId,
        switchedUserName: userDetails?.switchedUserName,
      };
      dispatch(updateSwitchedUserDetails(payLoad));
      loadHeaderDetails(false, false);
      setOpenProfilePopover(false);
    } catch (error: any) {
      setLoader(false);
      handleAxiosErrors(error);
    }
  };

  const logoutHandler = () => {
    try {
      logMessage(
        "INFO",
        `User ${userDetails?.userName} has clicked the logout button`,
        PageNames.DASHBOARD,
      );
      setOpenLoginAsPopover(false);
      logOut();
      sessionStorage.removeItem("DefautGridPageSize");
      dispatch(clearAuthState());
    } catch (error: any) {
      setLoader(false);
      handleAxiosErrors(error);
    }
  };

  const logOut = async () => {
    try {
      setLoader(true);
      const authState = store.getState();
      const APIHeaders = {
        Authorization: `Bearer ${authState.auth?.authDetails?.token}`,
      };
      dispatch(
        postLogsToAPI({
          logs,
          token: authState.auth?.authDetails?.token,
        }),
      );
      dispatch(clearlogs());
      const responseData = await getRequest({
        url:
          LOGOUT_USER_ENDPOINT +
          "?userIdentity=" +
          authState.auth?.userDetails?.userIdentity,
        headers: setHeader(APIHeaders),
        timeout: 60000,
        params: {},
      });
      if (isValidObject(responseData)) {
        window.location.href = CPSConstants.UNAUTH_QUERY_STRING;
      }
      setLoader(false);
    } catch (error: any) {
      loggedMessage(error, "", PageNames.DASHBOARD);
      setLoader(false);
      handleAxiosErrors(error);
    }
  };

  const handleTrainingDialogView = () => {
    try {
      logMessage(
        "INFO",
        `User ${userDetails?.userName} has opened the Training Dialog`,
        PageNames.DASHBOARD,
      );
      setOpenDialog(true);
    } catch (error: any) {
      setLoader(false);
      handleAxiosErrors(error);
    }
  };

  const handleContactUs = () => {
    try {
      logMessage(
        "INFO",
        `User ${userDetails?.userName} has opened the contact us page`,
        PageNames.DASHBOARD,
      );
      setContactView(true);
    } catch (error: any) {
      setLoader(false);
      handleAxiosErrors(error);
    }
  };

  const handleFrClick = () => {
    try {
      logMessage(
        "INFO",
        `User ${userDetails?.userName} has clicked the FR buttoon`,
        PageNames.DASHBOARD,
      );
    } catch (error: any) {
      setLoader(false);
      handleAxiosErrors(error);
    }
  };

  const handleCppClick = () => {
    try {
      logMessage(
        "INFO",
        `User ${userDetails?.userName} has clicked the CPP buttoon`,
        PageNames.LOGIN,
      );
    } catch (error: any) {
      setLoader(false);
      handleAxiosErrors(error);
    }
  };

  const enableDisableCloseIcon = () => {
    try {
      const trainingpopup = headerDetails?.showTrainingPopUp;
      return trainingpopup;
    } catch (error: any) {
      setLoader(false);
      handleAxiosErrors(error);
    }
  };

  const handleCloseTraining = () => {
    setOpenDialog(false);
  };

  const handleAxiosErrors = (error: any) => {
    const data = {pagename: PageNames.DASHBOARD};
    if (error?.code === AxiosErrorCode.ERR_BAD_REQUEST) {
      if (
        error?.response?.status === HttpStatusCode.UNAUTHORIZED ||
        error?.response?.status === HttpStatusCode.FORBIDDEN
      ) {
        ServiceAuthenticationException(error, data, error?.response?.status);
      } else if (error?.response?.status === HttpStatusCode.BAD_REQUEST) {
        // setErrorMsg(error.response.data.message);
      } else if (error?.response?.status === HttpStatusCode.NOT_FOUND) {
        // setErrorMsg(CPSConstants.SERVICE_NOT_FOUND);
      } else if (
        error?.response?.status === HttpStatusCode.INTERNAL_SERVER_ERROR
      ) {
        HttpException(error, data);
        // setErrorMsg(CPSConstants.INTERNAL_SERVER_ERROR);
      } else {
        // setErrorMsg(error.message);
      }
    } else if (error?.code === AxiosErrorCode.ECONNABORTED) {
      // setErrorMsg(CPSConstants.TIMEOUT_ERROR);
    } else if (error?.code === AxiosErrorCode.ERR_NETWORK) {
      // setErrorMsg(CPSConstants.NETWORK_ERROR);
    } else {
      // setErrorMsg(error.message);
    }
  };

  const handleMFAClick = () => {
    setOpenMFADialog(true);
  };

  return (
    <>
      {isbannertext && bannertext?.demoSite !== "0" && (
        <Marquee text={bannertext?.demoStripMessage} />
      )}
      <div className="app-header">
        <Box sx={{flexGrow: 1}}>
          {contactView && (
            <ContactUsDialog
              contactUsOpen={contactView}
              setContactView={setContactView}
              buttonname={"Submit"}
            />
          )}
          {openDialog && (
            <TrainingDialog
              trainingopen={openDialog}
              buttonCancel="Cancel"
              buttonSubmit="Submit"
              handleCloseTraining={handleCloseTraining}
              enableDisableCloseIcon={enableDisableCloseIcon()}
            />
          )}
          {openMFADialog && (
            <MFAPreferedDialog
              openDialog={openMFADialog}
              handleCloseMFA={() => {
                setOpenMFADialog(false);
              }}
              userId={userDetails?.userId}
            />
          )}

          <AppBar position="static" style={{background: "#11ffee00"}}>
            <Toolbar>
              <Typography variant="h6" component="div" sx={{flexGrow: 1}}>
                <div className="logo-header"></div>
              </Typography>

              <Loader open={loader} />
              <Box sx={{padding: 1}}>
                <Button
                  variant="outlined"
                  size="small"
                  sx={headerStyle.buttonStyle}
                  onClick={handleContactUs}>
                  <img
                    src={contactUs}
                    alt="my"
                    style={headerStyle.avatarStyle}
                  />
                  Contact Us
                </Button>
              </Box>
              <Divider
                orientation="vertical"
                flexItem
                className="menuDivider"
              />
              <Box sx={{padding: 1}}>
                <Button
                  variant="outlined"
                  size="small"
                  sx={headerStyle.buttonStyle}
                  onClick={handleTrainingDialogView}>
                  <img
                    src={trainingIcon}
                    alt="my"
                    style={headerStyle.avatarStyle}
                  />
                  Training
                </Button>
              </Box>
              <Divider
                orientation="vertical"
                flexItem
                className="menuDivider"
              />
              <Box sx={{padding: 1}}>
                <Button
                  aria-describedby={id2}
                  variant="outlined"
                  sx={headerStyle.buttonStyle}
                  size="small"
                  onClick={handleClick2}>
                  <img
                    src={profileIcon}
                    alt="profileIcon"
                    style={headerStyle.avatarStyle}
                  />
                  Profile
                  <img
                    src={dropdownIcon}
                    alt="dropdownIcon"
                    style={headerStyle.dropIconStyle}
                  />
                </Button>
                <Popover
                  id={id2}
                  open={opener2 && openProfilePopover}
                  anchorEl={anchorEl2}
                  onClose={handleClose2}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "center",
                  }}
                  PaperProps={{
                    style: {width: "auto"},
                  }}>
                  {" "}
                  <Box
                    sx={{
                      position: "relative",
                      mt: "10px",
                      "&::before": {
                        bgcolor: "#fff",
                        content: '""',
                        display: "block",
                        position: "absolute",
                        width: 12,
                        height: 12,
                        top: -6,
                        transform: "rotate(45deg)",
                        left: "calc(50% - 6px)",
                      },
                    }}
                  />
                  <Typography
                    component="p"
                    sx={{p: 2, backgroundColor: "white", padding: "0.625rem"}}>
                    <Typography
                      component="span"
                      sx={headerStyle.actingTypigraphy}>
                      Acting as:
                    </Typography>
                    <Card sx={{minWidth: 100, boxShadow: "none"}}>
                      <CardContent sx={{padding: "0"}}>
                        <FormControl sx={{minWidth: "20rem"}}>
                          <HeaderSelectComponent
                            labelId="userProfile"
                            id="userProfile"
                            size="small"
                            defaultValue={userDetails.profileId}
                            onChange={userProfileChange}
                            outlet={
                              Object.keys(headerDetails?.cpsUserProfiles || {})
                                .length !== 0 &&
                              headerDetails?.cpsUserProfiles?.map(
                                ({
                                  id,
                                  isPIAccess,
                                  profileName,
                                }: {
                                  id: number;
                                  isPIAccess: boolean;
                                  profileName: string;
                                }) => (
                                  <MenuItem
                                    className="main-font-family"
                                    key={id}
                                    value={id}
                                    sx={
                                      isPIAccess
                                        ? headerStyle.menuItemHide
                                        : headerStyle.menuItem
                                    }>
                                    {profileName}
                                  </MenuItem>
                                ),
                              )
                            }
                          />
                        </FormControl>
                       {(!userDetails.switchedUserName &&
                        userDetails.isMfaApplicable) &&
                          (<>
                          <Divider
                          sx={headerStyle.horizontalDivider}
                          orientation="horizontal"
                          flexItem
                        />
                        <Typography
                          component="span"
                          sx={headerStyle.actingTypigraphy}>
                          Multi-Factor Authentication:
                          {
                            <Link
                              sx={headerStyle.mFALink}
                              onClick={handleMFAClick}>
                              Click Here
                            </Link>
                          }
                        </Typography>
                        </>)}
                      </CardContent>
                    </Card>
                  </Typography>
                </Popover>
              </Box>
              <Divider
                orientation="vertical"
                flexItem
                className="menuDivider"
              />
              <Box sx={{padding: 1}}>
                <Button
                  aria-describedby={id}
                  variant="outlined"
                  size="small"
                  sx={headerStyle.buttonStyle}
                  onClick={handleClick}>
                  <img src={login} alt="my" style={headerStyle.avatarStyle} />
                  Login as: {userDetails.userName}
                  <img
                    src={dropdownIcon}
                    alt="dropdownIcon"
                    style={headerStyle.dropIconStyle}
                  />
                </Button>
                <Popover
                  id={id}
                  open={opener && openLoginAsPopover}
                  anchorEl={anchorEl}
                  onClose={handleClose}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "center",
                  }}
                  PaperProps={{
                    style: {
                      width: "auto",
                    },
                  }}>
                  {" "}
                  <Box
                    sx={{
                      position: "relative",
                      mt: "10px",
                      "&::before": {
                        bgcolor: "#fff",
                        content: '""',
                        display: "block",
                        position: "absolute",
                        width: 12,
                        height: 12,
                        top: -6,
                        transform: "rotate(45deg)",
                        left: "calc(50% - 6px)",
                      },
                    }}
                  />
                  <Typography
                    component="p"
                    sx={{p: 2, backgroundColor: "white", padding: "0.625rem"}}>
                    <Typography
                      component="span"
                      sx={headerStyle.typeGraphyUser}>
                      {userDetails.switchedUserName}
                    </Typography>
                    <Typography component="span" sx={headerStyle.typeGraphy}>
                      You are logged in as:
                    </Typography>
                    <Card sx={{minWidth: 100, boxShadow: "none"}}>
                      <CardContent sx={{padding: "0"}}>
                        <FormControl sx={{minWidth: "10rem"}}>
                          <HeaderSelectComponent
                            labelId="user"
                            id="user"
                            size="small"
                            style={headerStyle.selectStyle}
                            defaultValue={userDetails?.userId}
                            onChange={userChange}
                            outlet={
                              Object.keys(headerDetails?.userList || {})
                                .length !== 0 &&
                              headerDetails?.userList?.map(
                                ({
                                  userId,
                                  userName,
                                }: {
                                  userId: number;
                                  userName: string;
                                }) => (
                                  <MenuItem
                                    className="main-font-family"
                                    key={userId}
                                    value={userId}
                                    sx={headerStyle.menuItem}>
                                    {userName}
                                  </MenuItem>
                                ),
                              )
                            }
                          />
                        </FormControl>
                        <Button
                          size="small"
                          type="submit"
                          sx={headerStyle.logOutSytle}
                          onClick={logoutHandler}>
                          Logout
                        </Button>
                      </CardContent>
                      {headerDetails?.isJumpToVisible && (
                        <>
                          <Divider sx={{p: "0.5rem"}} />
                          <Typography component="p" sx={headerStyle.typeGraphy}>
                            {headerDetails?.isJumpToVisible ? "Jump to:" : ""}
                          </Typography>
                          <CardContent sx={{padding: "0"}}>
                            <>
                              {headerDetails?.frJumpTo !== "" ? (
                                <Button
                                  variant="outlined"
                                  sx={headerStyle.FrCppStyle}
                                  href={headerDetails?.frJumpTo}
                                  onClick={handleFrClick}
                                  target="_blank">
                                  FR
                                </Button>
                              ) : (
                                ""
                              )}
                              {headerDetails?.cppJumpTo !== "" ? (
                                <Button
                                  variant="outlined"
                                  sx={headerStyle.FrCppStyle}
                                  href={headerDetails?.cppJumpTo}
                                  onClick={handleCppClick}
                                  target="_blank">
                                  CPP
                                </Button>
                              ) : (
                                ""
                              )}
                            </>
                          </CardContent>
                        </>
                      )}
                    </Card>
                  </Typography>
                </Popover>
              </Box>
            </Toolbar>
          </AppBar>
        </Box>
      </div>
    </>
  );
};

export default Header;
